<template>
    <div>
        <b-row v-if="loading || currentLoad">
            <b-col>
                <b-spinner small />
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col v-show="isEdit">
                <b-form-select
                    v-model="current"
                    :options="options"
                    :valueField="valueField"
                    :textField="textField"
                    :state="validateFeedback()"
                    aria-describedby="setInvalidFeedbackName(index)"
                    @change="save"
                />
                <b-form-invalid-feedback
                    v-show="!current && canShowError"
                    id="setInvalidFeedbackName(index)"
                >
                    {{ $t("custom.selectEditField.formSelectError") }}
                </b-form-invalid-feedback>
            </b-col>
            <b-col
                v-show="!isEdit"
                @click="buttonClick"
            >
                {{ title }}
            </b-col>
            <b-col
                v-show="canShowEditField"
            >
                <edit-field
                    :loading="loading"
                    @isEdit="buttonClick"
                />
            </b-col>
            <b-col md="1">
                <i
                    class="icon cursor-pointer"
                    :class="{'icon-edit': !isEdit, 'icon-times': isEdit}"
                    @click="buttonClick"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import getModalConfirmConfig from '@/config/modalConfirm';

export default {
    name: 'SelectEditField',
    props: {
        loading: {
            type: Boolean,
            'default': false,
        },

        name: {
            type: String,
            'default': null,
        },

        url: {
            type: String,
            required: true,
        },

        options: {
            type: Array,
            'default': function() {
                return [];
            },
        },

        label: {
            type: String,
            'default': '',
        },

        valueField: {
            type: String,
            'default': 'id',
        },

        textField: {
            type: String,
            'default': 'description',
        },

        value: {
            type: [String, Number, Object, Boolean],
            required: true,
        },

        modalText: {
            type: String,
            'default': null,
        },

        planDateIssued: {
            type: Date,
            'default': null,
        },

        planDateIssuedEdit: {
            type: Boolean,
            'default': false,
        },

        canShowError: {
            type: Boolean,
            'default': true,
        },

        canShowEditField: {
            type: Boolean,
            'default': false,
        },
    },

    inject: ['getResponse'],
    data() {
        return {
            currentLoad: false,
            current: this.value,
            isEdit: !this.dateChecked(),
            oldValue: this.value,
        };
    },

    computed: {
        title: function() {
            if (this.label) {
                return this.label;
            }

            const label = this.options.find(item => this.current === item[this.valueField]);
            return label ? label[this.textField] : '';
        },
    },

    methods: {
        save: function() {
            if (!this.modalText) {
                this.send();

                return;
            }

            this.$bvModal.msgBoxConfirm(this.modalText, getModalConfirmConfig())
                ?.then(value => {
                    if (!value) {
                        this.current = this.oldValue;
                        return;
                    }
                    this.send();
                },
                );
        },

        send: function() {
            this.$emit('update:loading', true);
            this.currentLoad = true;
            this.axios.put(this.url, this.getDataParams())
                .then((response) => {
                    this.currentLoad = false;
                    this.oldValue = this.current;
                    this.$emit('update:loading', false);
                });

            return true;
        },

        buttonClick: function() {
            this.isEdit = !this.isEdit;

            this.$emit('btn:click', this.isEdit);
        },

        getDataParams: function() {
            let data = {};
            if (typeof this.current !== 'object') {
                data[this.name] = this.current;
                data.planDateIssued = this.planDateIssued;
            } else {
                data = this.current;
            }

            return data;
        },

        dateChecked: function() {
            return !this.planDateIssuedEdit;
        },

        validateFeedback: function() {
            return this.current !== null ? null : false;
        },

        SelectFieldEdit: function(isEdit) {
            return this.$emit('is-edit', isEdit);
        },
    },

    watch: {
        current: function() {
            this.$emit('input', this.current);
        },

        value: function() {
            this.$emit('wait-reason-id', this.value);
            this.current = this.value;
        },
    },
};
</script>